import { AccessGrant, Mutation } from 'graphql/generated/graphqlTypes';
import { generateMockAccessGrant } from 'mocks/graphqlMocks/accessGrant';
import { generateMockDoor } from 'mocks/graphqlMocks/door';

export function mockedUnassignAccessGrantsToDoors(
  unassignAccessGrantsFromDoors: AccessGrant[]
): Pick<Mutation, 'unassignAccessGrantsFromDoors'> {
  return {
    unassignAccessGrantsFromDoors
  };
}

export const mockedUnassignAccessGrantsToDoorsDataForMutation = mockedUnassignAccessGrantsToDoors([
  generateMockAccessGrant({ id: 'mockedAccessGrantId', doors: [generateMockDoor({ id: 'mockedDoorId' })] })
]);
